import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFunnelRemove$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFunnelRemove extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'dbc027b4d2c9758179c957097c67d29e030395a6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ebcda000d0439522a6ee2ec0ac274e89fbad17d0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6f609b5c6243e1c5d76fd670f09f52b68eaeca02', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.82 1.614c.24.24.24.628 0 .867l-1.518 1.52 1.518 1.518c.24.24.24.628 0 .868l-.433.433a.614.614 0 0 1-.868 0L16 5.302 14.481 6.82a.614.614 0 0 1-.867 0l-.434-.433a.614.614 0 0 1 0-.868L14.698 4 13.18 2.481a.614.614 0 0 1 0-.867l.434-.434c.24-.24.628-.24.867 0l1.52 1.518 1.518-1.518c.24-.24.628-.24.868 0zM8.5 18.96a.5.5 0 0 0 .812.39l4-3.2a.5.5 0 0 0 .188-.39V11l1.8-2h-2.018L12 10.425v4.854l-2 1.6v-6.455l-4.5-5V4.5H11V3H4.5a.5.5 0 0 0-.5.5v2.308a.5.5 0 0 0 .128.335L8.5 11z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-funnel-remove", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-funnel-remove"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-funnel-remove":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFunnelRemove$1);
            }
            break;
    } });
}

const CosmosIconFunnelRemove = CosmosIconFunnelRemove$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFunnelRemove, defineCustomElement };
